function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var t = /*#__PURE__*/function (_Date) {
  _inherits(t, _Date);

  var _super = _createSuper(t);

  function t() {
    var _temp, _this;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY-MM-DD";
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";

    _classCallCheck(this, t);

    (_temp = _this = _super.call(this, t.parseDateTime(e, s, n)), _this.lang = void 0, _temp), _this.lang = n;
    return _this;
  }

  _createClass(t, [{
    key: "getWeek",
    value: function getWeek(_t3) {
      var e = new Date(this.midnight_ts(this)),
          s = (this.getDay() + (7 - _t3)) % 7;
      e.setDate(e.getDate() - s);
      var n = e.getTime();
      return e.setMonth(0, 1), e.getDay() !== _t3 && e.setMonth(0, 1 + (4 - e.getDay() + 7) % 7), 1 + Math.ceil((n - e.getTime()) / 6048e5);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new t(this);
    }
  }, {
    key: "toJSDate",
    value: function toJSDate() {
      return new Date(this);
    }
  }, {
    key: "inArray",
    value: function inArray(_t4) {
      var _this2 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "[]";
      return _t4.some(function (_t5) {
        return _t5 instanceof Array ? _this2.isBetween(_t5[0], _t5[1], e) : _this2.isSame(_t5, "day");
      });
    }
  }, {
    key: "isBetween",
    value: function isBetween(_t6, e) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "()";

      switch (s) {
        default:
        case "()":
          return this.midnight_ts(this) > this.midnight_ts(_t6) && this.midnight_ts(this) < this.midnight_ts(e);

        case "[)":
          return this.midnight_ts(this) >= this.midnight_ts(_t6) && this.midnight_ts(this) < this.midnight_ts(e);

        case "(]":
          return this.midnight_ts(this) > this.midnight_ts(_t6) && this.midnight_ts(this) <= this.midnight_ts(e);

        case "[]":
          return this.midnight_ts() >= this.midnight_ts(_t6) && this.midnight_ts() <= this.midnight_ts(e);
      }
    }
  }, {
    key: "isBefore",
    value: function isBefore(_t7) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(_t7.getFullYear(), _t7.getMonth(), _t7.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();

        case "month":
        case "months":
          return new Date(_t7.getFullYear(), _t7.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();

        case "year":
        case "years":
          return _t7.getFullYear() > this.getFullYear();
      }

      throw new Error("isBefore: Invalid unit!");
    }
  }, {
    key: "isSameOrBefore",
    value: function isSameOrBefore(_t8) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(_t8.getFullYear(), _t8.getMonth(), _t8.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();

        case "month":
        case "months":
          return new Date(_t8.getFullYear(), _t8.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
      }

      throw new Error("isSameOrBefore: Invalid unit!");
    }
  }, {
    key: "isAfter",
    value: function isAfter(_t9) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(_t9.getFullYear(), _t9.getMonth(), _t9.getDate()).getTime();

        case "month":
        case "months":
          return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(_t9.getFullYear(), _t9.getMonth(), 1).getTime();

        case "year":
        case "years":
          return this.getFullYear() > _t9.getFullYear();
      }

      throw new Error("isAfter: Invalid unit!");
    }
  }, {
    key: "isSameOrAfter",
    value: function isSameOrAfter(_t10) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(_t10.getFullYear(), _t10.getMonth(), _t10.getDate()).getTime();

        case "month":
        case "months":
          return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(_t10.getFullYear(), _t10.getMonth(), 1).getTime();
      }

      throw new Error("isSameOrAfter: Invalid unit!");
    }
  }, {
    key: "isSame",
    value: function isSame(_t11) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(_t11.getFullYear(), _t11.getMonth(), _t11.getDate()).getTime();

        case "month":
        case "months":
          return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(_t11.getFullYear(), _t11.getMonth(), 1).getTime();
      }

      throw new Error("isSame: Invalid unit!");
    }
  }, {
    key: "add",
    value: function add(_t12) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          this.setDate(this.getDate() + _t12);
          break;

        case "month":
        case "months":
          this.setMonth(this.getMonth() + _t12);
      }

      return this;
    }
  }, {
    key: "subtract",
    value: function subtract(_t13) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          this.setDate(this.getDate() - _t13);
          break;

        case "month":
        case "months":
          this.setMonth(this.getMonth() - _t13);
      }

      return this;
    }
  }, {
    key: "diff",
    value: function diff(_t14) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        default:
        case "day":
        case "days":
          return Math.round((this.midnight_ts() - this.midnight_ts(_t14)) / 864e5);

        case "month":
        case "months":
          var _e = 12 * (_t14.getFullYear() - this.getFullYear());

          return _e -= _t14.getMonth(), _e += this.getMonth(), _e;
      }
    }
  }, {
    key: "format",
    value: function format(e) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
      var n = "";
      var r = [];
      var a = null;

      for (; null != (a = t.regex.exec(e));) {
        "\\" !== a[1] && r.push(a);
      }

      if (r.length) {
        r[0].index > 0 && (n += e.substring(0, r[0].index));

        for (var _i2 = 0, _Object$entries = Object.entries(r); _i2 < _Object$entries.length; _i2++) {
          var _ref3 = _Object$entries[_i2];

          var _ref2 = _slicedToArray(_ref3, 2);

          var _t17 = _ref2[0];
          var _a = _ref2[1];
          var i = Number(_t17);
          n += this.formatTokens(_a[0], s), r[i + 1] && (n += e.substring(_a.index + _a[0].length, r[i + 1].index)), i === r.length - 1 && (n += e.substring(_a.index + _a[0].length));
        }
      }

      return n.replace(/\\/g, "");
    }
  }, {
    key: "midnight_ts",
    value: function midnight_ts(_t16) {
      return _t16 ? new Date(_t16.getFullYear(), _t16.getMonth(), _t16.getDate(), 0, 0, 0, 0).getTime() : new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
    }
  }, {
    key: "formatTokens",
    value: function formatTokens(e, s) {
      switch (e) {
        case "YY":
          return String(this.getFullYear()).slice(-2);

        case "YYYY":
          return String(this.getFullYear());

        case "M":
          return String(this.getMonth() + 1);

        case "MM":
          return "0".concat(this.getMonth() + 1).slice(-2);

        case "MMM":
          return t.shortMonths(s)[this.getMonth()];

        case "MMMM":
          return t.longMonths(s)[this.getMonth()];

        case "D":
          return String(this.getDate());

        case "DD":
          return "0".concat(this.getDate()).slice(-2);

        case "H":
          return String(this.getHours());

        case "HH":
          return "0".concat(this.getHours()).slice(-2);

        case "h":
          return String(this.getHours() % 12 || 12);

        case "hh":
          return "0".concat(this.getHours() % 12 || 12).slice(-2);

        case "m":
          return String(this.getMinutes());

        case "mm":
          return "0".concat(this.getMinutes()).slice(-2);

        case "s":
          return String(this.getSeconds());

        case "ss":
          return "0".concat(this.getSeconds()).slice(-2);

        case "a":
          return this.getHours() < 12 || 24 === this.getHours() ? "am" : "pm";

        case "A":
          return this.getHours() < 12 || 24 === this.getHours() ? "AM" : "PM";

        default:
          return "";
      }
    }
  }], [{
    key: "parseDateTime",
    value: function parseDateTime(e) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY-MM-DD";
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";
      if (!e) return new Date(new Date().setHours(0, 0, 0, 0));
      if (e instanceof t) return e.toJSDate();
      if (e instanceof Date) return e;
      if (/^-?\d{10,}$/.test(String(e))) return new Date(Number(e));

      if ("string" == typeof e) {
        var r = [];
        var a = null;

        for (; null != (a = t.regex.exec(s));) {
          "\\" !== a[1] && r.push(a);
        }

        if (r.length) {
          var _s2 = {
            year: null,
            month: null,
            shortMonth: null,
            longMonth: null,
            day: null,
            hour: 0,
            minute: 0,
            second: 0,
            ampm: null,
            value: ""
          };
          r[0].index > 0 && (_s2.value += ".*?");

          for (var _i3 = 0, _Object$entries2 = Object.entries(r); _i3 < _Object$entries2.length; _i3++) {
            var _ref6 = _Object$entries2[_i3];

            var _ref5 = _slicedToArray(_ref6, 2);

            var _e2 = _ref5[0];
            var _a3 = _ref5[1];

            var _r = Number(_e2),
                _t$formatPatterns = t.formatPatterns(_a3[0], n),
                i = _t$formatPatterns.group,
                h = _t$formatPatterns.pattern;

            _s2[i] = _r + 1, _s2.value += h, _s2.value += ".*?";
          }

          var _a2 = new RegExp("^".concat(_s2.value, "$"));

          if (_a2.test(e)) {
            var _r2 = _a2.exec(e),
                _i4 = Number(_r2[_s2.year]);

            var _h = null;
            _s2.month ? _h = Number(_r2[_s2.month]) - 1 : _s2.shortMonth ? _h = t.shortMonths(n).indexOf(_r2[_s2.shortMonth]) : _s2.longMonth && (_h = t.longMonths(n).indexOf(_r2[_s2.longMonth]));
            var g = Number(_r2[_s2.day]) || 1,
                o = Number(_r2[_s2.hour]);
            var u = Number.isNaN(o) ? 0 : o;
            var c = Number(_r2[_s2.minute]),
                l = Number.isNaN(c) ? 0 : c,
                m = Number(_r2[_s2.second]),
                d = Number.isNaN(m) ? 0 : m,
                M = _r2[_s2.ampm];
            return M && "PM" === M && (u += 12, 24 === u && (u = 0)), new Date(_i4, _h, g, u, l, d, 0);
          }
        }
      }

      return new Date(new Date().setHours(0, 0, 0, 0));
    }
  }, {
    key: "shortMonths",
    value: function shortMonths(e) {
      return t.MONTH_JS.map(function (_t) {
        return new Date(2019, _t).toLocaleString(e, {
          month: "short"
        });
      });
    }
  }, {
    key: "longMonths",
    value: function longMonths(e) {
      return t.MONTH_JS.map(function (_t2) {
        return new Date(2019, _t2).toLocaleString(e, {
          month: "long"
        });
      });
    }
  }, {
    key: "formatPatterns",
    value: function formatPatterns(e, s) {
      switch (e) {
        case "YY":
        case "YYYY":
          return {
            group: "year",
            pattern: "(\\d{".concat(e.length, "})")
          };

        case "M":
          return {
            group: "month",
            pattern: "(\\d{1,2})"
          };

        case "MM":
          return {
            group: "month",
            pattern: "(\\d{2})"
          };

        case "MMM":
          return {
            group: "shortMonth",
            pattern: "(".concat(t.shortMonths(s).join("|"), ")")
          };

        case "MMMM":
          return {
            group: "longMonth",
            pattern: "(".concat(t.longMonths(s).join("|"), ")")
          };

        case "D":
          return {
            group: "day",
            pattern: "(\\d{1,2})"
          };

        case "DD":
          return {
            group: "day",
            pattern: "(\\d{2})"
          };

        case "h":
        case "H":
          return {
            group: "hour",
            pattern: "(\\d{1,2})"
          };

        case "hh":
        case "HH":
          return {
            group: "hour",
            pattern: "(\\d{2})"
          };

        case "m":
          return {
            group: "minute",
            pattern: "(\\d{1,2})"
          };

        case "mm":
          return {
            group: "minute",
            pattern: "(\\d{2})"
          };

        case "s":
          return {
            group: "second",
            pattern: "(\\d{1,2})"
          };

        case "ss":
          return {
            group: "second",
            pattern: "(\\d{2})"
          };

        case "a":
        case "A":
          return {
            group: "ampm",
            pattern: "(AM|PM|am|pm)"
          };
      }
    }
  }]);

  return t;
}( /*#__PURE__*/_wrapNativeSuper(Date));

t.regex = /(\\)?(Y{2,4}|M{1,4}|D{1,2}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|A|a)/g;
t.MONTH_JS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export { t as DateTime };